import FusionCharts, {ChartObject, FusionCharts as FusionChartsType} from 'fusioncharts';
import Charts from 'fusioncharts/fusioncharts.charts';
import PowerCharts from 'fusioncharts/fusioncharts.powercharts';
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';
import ReactFC from 'react-fusioncharts';

import {getConfig} from '@/config';

type ReactFCProps = ChartObject & {onRender?: (chart: FusionChartsType) => void};

// @ts-ignore: Suppressing type error temporarily until fusioncharts types are updated
FusionCharts.options.license({
    key: getConfig().FUSION_CHARTS_LICENSE_KEY,
    creditLabel: false
});

ReactFC.fcRoot(FusionCharts, Charts, PowerCharts, FusionTheme);

export const FusionChart = (props: ReactFCProps) => {
    // @ts-ignore: Suppressing type error temporarily until react-fusioncharts is updated
    return <ReactFC {...props} />;
};
